import { create } from 'zustand';
import { countOpenReviews } from '../lib/supabase';

/** Zahl der Mails, die auf die Redaktion warten (Seitenleiste „Freigaben"). */
interface FreigabenStore {
  anzahl: number;
  laden: () => Promise<void>;
}

export const useFreigabenStore = create<FreigabenStore>((set) => ({
  anzahl: 0,
  laden: async () => {
    try {
      set({ anzahl: await countOpenReviews() });
    } catch {
      // Die Zahl ist nur ein Hinweis — ohne sie geht es auch.
    }
  },
}));
